/*
  automation_ready.js enabled automation tests on non prod tiers
 */
$(document).ready(() => $('body').addClass('selenium_ready'));
